// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: S6vw5IJzcaua
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import DashboardInProgressStatusCard from "../../DashboardInProgressStatusCard"; // plasmic-import: kbABk64qZGb_/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicDashboardContractsCard.module.css"; // plasmic-import: S6vw5IJzcaua/css

createPlasmicElementProxy;

export const PlasmicDashboardContractsCard__VariantProps = new Array();

export const PlasmicDashboardContractsCard__ArgProps = new Array(
  "amount",
  "client",
  "date"
);

const $$ = {};

function PlasmicDashboardContractsCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <Stack__
      as={"div"}
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      hasGap={true}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__n132B)}>
        {renderPlasmicSlot({
          defaultContents: "$1040.00",
          value: args.amount,
          className: classNames(sty.slotTargetAmount)
        })}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__ff6Au)}>
        {renderPlasmicSlot({
          defaultContents: "McDonalds",
          value: args.client,
          className: classNames(sty.slotTargetClient)
        })}
      </div>
      <div
        data-plasmic-name={"statusStack"}
        data-plasmic-override={overrides.statusStack}
        className={classNames(projectcss.all, sty.statusStack)}
      >
        <DashboardInProgressStatusCard
          data-plasmic-name={"dashboardInProgressStatusCard"}
          data-plasmic-override={overrides.dashboardInProgressStatusCard}
          className={classNames(
            "__wab_instance",
            sty.dashboardInProgressStatusCard
          )}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__odFF)}>
        {renderPlasmicSlot({
          defaultContents: "Dec 28th",
          value: args.date,
          className: classNames(sty.slotTargetDate)
        })}
      </div>
    </Stack__>
  );
}

const PlasmicDescendants = {
  root: ["root", "statusStack", "dashboardInProgressStatusCard"],
  statusStack: ["statusStack", "dashboardInProgressStatusCard"],
  dashboardInProgressStatusCard: ["dashboardInProgressStatusCard"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicDashboardContractsCard__ArgProps,
          internalVariantPropNames: PlasmicDashboardContractsCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicDashboardContractsCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicDashboardContractsCard";
  } else {
    func.displayName = `PlasmicDashboardContractsCard.${nodeName}`;
  }
  return func;
}

export const PlasmicDashboardContractsCard = Object.assign(
  // Top-level PlasmicDashboardContractsCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    statusStack: makeNodeComponent("statusStack"),
    dashboardInProgressStatusCard: makeNodeComponent(
      "dashboardInProgressStatusCard"
    ),
    // Metadata about props expected for PlasmicDashboardContractsCard
    internalVariantProps: PlasmicDashboardContractsCard__VariantProps,
    internalArgProps: PlasmicDashboardContractsCard__ArgProps
  }
);

export default PlasmicDashboardContractsCard;
/* prettier-ignore-end */
